<template>
     <div class="share-with">{{$t("spShareWith")}} <a href="#"><img src="../../common/images/common/facebook.png" alt="facebook" width="32" height="32"></a>
        <a href="#"><img src="../../common/images/common/sina.png" alt="sina" width="32" height="32"></a>
        <a href="#"><img src="../../common/images/common/twitter.png" alt="twitter" width="32" height="32"></a>
        <a href="#"><img src="../../common/images/common/ins.png" alt="ins" width="32" height="32"></a>
    </div>
</template>

<script>
export default {
    name: "Share"
}
</script>



// WEBPACK FOOTER //
// src/components/common/share.vue